import { Divider } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import React, { useContext, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import WindsorApi from '../api/WindsorApi';
import LinkRouter from '../common/LinkRouter';
import LoadingIndicator from '../common/LoadingIndicator';
import MobxContext from '../mobx/MobxContext';
import FamilySettingsForm from './FamilySettingsForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    },
    breadcrumb: {
      marginBottom: 16
    }
  })
);

const windsorApi = new WindsorApi();

function CreateFamilyPage(props: RouteComponentProps<any> & WithSnackbarProps) {
  const { history, enqueueSnackbar } = props;
  const classes = useStyles({});
  const [family, setFamily] = useState({
    Name: '',
    Description: '',
    Groups: {
      FamilyAdmins: []
    },
    AllowedARNs: []
  });
  const { cspGroupStore } = useContext(MobxContext);

  const onFamilyChange = (family: any) => {
    setFamily(family);
  };

  const onSave = () => {
    return windsorApi.createFamily(family);
  };

  const onSaveComplete = (newFamily: any) => {
    enqueueSnackbar('Family created');
    history.push(`/families/${newFamily.GUID}?tab=settings`);
  };

  const onCancel = () => {
    history.push(`/families`);
  };

  return cspGroupStore.groups ? (
    <div className={classes.root}>
      <Breadcrumbs aria-label="breadcrumb">
        <LinkRouter color="textSecondary" to="/families">
          Families
        </LinkRouter>
        <Typography color="textPrimary">new</Typography>
      </Breadcrumbs>
      <Divider className={classes.divider} light />
      <FamilySettingsForm 
        title="Create Family"
        family={family} 
        groups={cspGroupStore.groups}
        onFamilyChange={onFamilyChange} 
        onSave={onSave}
        onSaveComplete={onSaveComplete}
        onCancel={onCancel}
      />
    </div>
  ) : <LoadingIndicator loading={true} />;
};

export default withRouter(withSnackbar(observer(CreateFamilyPage)));
